import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { TaskConfigurationRoutes } from '../../../routes/HomeRoutes';

export const TaskConfigurationLayout = () => <SwitchRoute routes={TaskConfigurationRoutes} />;
